import axios from 'axios';
// utils
import localStorageAvailable from './localStorageAvailable';
// config
import { HOST_API_KEY } from '../config-global';

// ----------------------------------------------------------------------
const storageAvailable = localStorageAvailable();
const axiosInstance = axios.create({ baseURL: HOST_API_KEY });

const getStoredAccessToken = () => (storageAvailable ? localStorage.getItem('accessToken') : '');

const isSessionInvalidResponse = (payload) => {
  if (!getStoredAccessToken() || !payload || typeof payload !== 'object') {
    return false;
  }

  const { code, message } = payload;

  if (code === 401) {
    return true;
  }

  if (code === 403 && message === 'Not token provided') {
    return true;
  }

  if (code === 404 && message === 'User does not exist') {
    return true;
  }

  if (code === 414 && message === 'User is not active') {
    return true;
  }

  return false;
};

const dispatchUnauthorizedEvent = (payload) => {
  window.dispatchEvent(
    new CustomEvent('unauthorized', {
      detail: {
        code: payload?.code ?? null,
        message: payload?.message ?? '',
      },
    })
  );
};

axiosInstance.interceptors.response.use(
  (response) => {
    if (isSessionInvalidResponse(response.data)) {
      dispatchUnauthorizedEvent(response.data);
    }
    return response;
  },
  (error) => {
    const responseData = error.response && error.response.data;

    if (isSessionInvalidResponse(responseData)) {
      dispatchUnauthorizedEvent(responseData);
    }

    return Promise.reject(responseData || 'Something went wrong');
  }
);

export default axiosInstance;
